import _extends from "@babel/runtime/helpers/extends";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React, { forwardRef, useImperativeHandle, useRef, useState } from "react";
import { useIntl } from "react-intl";
import { CheckoutPayment } from "@components/organisms";
import { useCheckout } from "@saleor/sdk";
import { commonMessages } from "@temp/intl";

var CheckoutPaymentSubpageWithRef = function CheckoutPaymentSubpageWithRef(_ref, ref) {
  var paymentGatewayFormRef = _ref.paymentGatewayFormRef,
      changeSubmitProgress = _ref.changeSubmitProgress,
      onSubmitSuccess = _ref.onSubmitSuccess,
      onPaymentGatewayError = _ref.onPaymentGatewayError,
      props = _objectWithoutProperties(_ref, ["paymentGatewayFormRef", "changeSubmitProgress", "onSubmitSuccess", "onPaymentGatewayError"]);

  var _useCheckout = useCheckout(),
      promoCodeDiscount = _useCheckout.promoCodeDiscount,
      addPromoCode = _useCheckout.addPromoCode,
      removePromoCode = _useCheckout.removePromoCode;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      promoCodeErrors = _useState2[0],
      setPromoCodeErrors = _useState2[1];

  var promoCodeDiscountFormId = "discount-form";
  var promoCodeDiscountFormRef = useRef(null);
  var intl = useIntl();
  useImperativeHandle(ref, function () {
    return {
      submitPayment: function submitPayment() {
        if (promoCodeDiscountFormRef.current) {
          var _promoCodeDiscountFor;

          (_promoCodeDiscountFor = promoCodeDiscountFormRef.current) === null || _promoCodeDiscountFor === void 0 ? void 0 : _promoCodeDiscountFor.dispatchEvent(new Event("submit", {
            cancelable: true
          }));
        } else if (paymentGatewayFormRef.current) {
          paymentGatewayFormRef.current.dispatchEvent(new Event("submit", {
            cancelable: true
          }));
        } else {
          changeSubmitProgress(false);
          onPaymentGatewayError([{
            message: intl.formatMessage(commonMessages.choosePaymentMethod)
          }]);
        }
      }
    };
  });

  var handleAddPromoCode =
  /*#__PURE__*/
  function () {
    var _ref2 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(promoCode) {
      var _ref3, dataError, errors;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return addPromoCode(promoCode);

            case 2:
              _ref3 = _context.sent;
              dataError = _ref3.dataError;
              errors = dataError === null || dataError === void 0 ? void 0 : dataError.error;

              if (errors) {
                changeSubmitProgress(false);
                setPromoCodeErrors(errors);
              } else {
                setPromoCodeErrors([]);

                if (paymentGatewayFormRef.current) {
                  paymentGatewayFormRef.current.dispatchEvent(new Event("submit", {
                    cancelable: true
                  }));
                } else {
                  changeSubmitProgress(false);
                  onPaymentGatewayError([{
                    message: intl.formatMessage(commonMessages.choosePaymentMethod)
                  }]);
                }
              }

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleAddPromoCode(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleRemovePromoCode =
  /*#__PURE__*/
  function () {
    var _ref4 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2(promoCode) {
      var _ref5, dataError, errors;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return removePromoCode(promoCode);

            case 2:
              _ref5 = _context2.sent;
              dataError = _ref5.dataError;
              errors = dataError === null || dataError === void 0 ? void 0 : dataError.error;

              if (errors) {
                changeSubmitProgress(false);
                setPromoCodeErrors(errors);
              } else {
                setPromoCodeErrors([]);

                if (paymentGatewayFormRef.current) {
                  paymentGatewayFormRef.current.dispatchEvent(new Event("submit", {
                    cancelable: true
                  }));
                } else {
                  changeSubmitProgress(false);
                  onPaymentGatewayError([{
                    message: intl.formatMessage(commonMessages.choosePaymentMethod)
                  }]);
                }
              }

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleRemovePromoCode(_x2) {
      return _ref4.apply(this, arguments);
    };
  }();

  var handleSubmitUnchangedDiscount = function handleSubmitUnchangedDiscount() {
    if (paymentGatewayFormRef.current) {
      paymentGatewayFormRef.current.dispatchEvent(new Event("submit", {
        cancelable: true
      }));
    } else {
      changeSubmitProgress(false);
      onPaymentGatewayError([{
        message: intl.formatMessage(commonMessages.choosePaymentMethod)
      }]);
    }
  };

  return React.createElement(CheckoutPayment, _extends({}, props, {
    promoCodeDiscountFormId: promoCodeDiscountFormId,
    promoCodeDiscountFormRef: promoCodeDiscountFormRef,
    promoCodeDiscount: {
      voucherCode: promoCodeDiscount === null || promoCodeDiscount === void 0 ? void 0 : promoCodeDiscount.voucherCode
    },
    addPromoCode: handleAddPromoCode,
    removeVoucherCode: handleRemovePromoCode,
    submitUnchangedDiscount: handleSubmitUnchangedDiscount,
    promoCodeErrors: promoCodeErrors
  }));
};

var CheckoutPaymentSubpage = forwardRef(CheckoutPaymentSubpageWithRef);
export { CheckoutPaymentSubpage };